import { computed, ref, Ref, watch } from "vue";
import { GenericField } from "@/business/shared/commons/validator/validatorsTypes";
import { RequiredRule } from "@/business/shared/commons/validator/rules/RequiredRule";
import { validator } from "@/business/shared/commons/validator/validator";

export function reasonCancellationValidator() {
  const reason: Ref<GenericField> = ref({
    enabled: false,
    errors: [],
    isSuccess: true,
    val: "",
    rules: [new RequiredRule("El motivo de anulación es obligatorio")],
  });

  watch(
    () => reason.value.val,
    () => {
      if ((reason.value.val?.length ?? 0) > 0) {
        reason.value.enabled = true;
      }
    }
  );


  function validate(field: GenericField, otherValue?: string): GenericField {
    return validator().validateField(field, otherValue);
  }

  const successForm = computed(() => {
    reason.value = validate(reason.value);


    return !(
      reason.value.isSuccess
    );
  });

  function reset(): void {
    reason.value.val = "";
    reason.value.enabled = false;
  }

  return {
    reason,
    successForm,
    reset,
  };
}
